import { API_URL } from "@/constants/envVariables";

import { handleApiResponse } from "@/api/handleApiResponse";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

import { ApiDisbursement, DisbursementEditableFields } from "@/types";

/**
 * Updates the editable fields of a disbursement that has not started yet. Fields left
 * out of `fields` are not changed.
 */
export const patchDisbursement = async (
  token: string,
  disbursementId: string,
  fields: DisbursementEditableFields,
): Promise<ApiDisbursement> => {
  const body: Record<string, string> = {};

  if (fields.name !== undefined) {
    body.name = fields.name;
  }
  if (fields.language !== undefined) {
    body.language = fields.language;
  }
  if (fields.receiverRegistrationMessageTemplate !== undefined) {
    body.receiver_registration_message_template = fields.receiverRegistrationMessageTemplate;
  }

  const response = await fetch(`${API_URL}/disbursements/${disbursementId}`, {
    method: "PATCH",
    credentials: getAuthCredentials(),
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeaders(token),
    },
    body: JSON.stringify(body),
  });

  return handleApiResponse(response);
};
